export default (() => ({
  productsPerPage: 40
}));